import { render, staticRenderFns } from "./BaseWalletValues.vue?vue&type=template&id=64262246&"
var script = {}
import style0 from "./BaseWalletValues.vue?vue&type=style&index=0&id=64262246&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports